import Vue from 'vue';
import axios from 'axios';
import App from './components/App.vue';
import router from './config/router';
import store from './config/store';
import Portal from 'portal-vue';
import './config/service';

import FormInput from './components/library/FormInput';
import SelectInput from './components/library/SelectInput';

Vue.config.productionTip = false;
Vue.use(Portal);
Vue.component('FormInput', FormInput);
Vue.component('SelectInput', SelectInput);

const token = localStorage.getItem('user-token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401 || error.response.status === 403) {
      return store.dispatch('AUTH_LOGOUT');
    } else {
      return Promise.reject(error);
    }
  }
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

console.log(process.env);
